<template lang="html">
  <div class="fsd-job-detail">
    <div class="fsd-job-detail__content">
      <div class="fsd-job-meta">
        <h1 class="fsd-job-meta__title">
          {{ 'client.fused.job.offline.header' | t }}
        </h1>
        <span
          class="button button--primary fsd-footer-actions__apply-button"
          @click="newSearchButton"
          >{{ 'client.fused.job.offline.link_text' | t }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations(['resultsJobUserSelectedSet']),
    ...mapActions(['forceResultUpdate']),
    newSearchButton() {
      this.resultsJobUserSelectedSet(false)
      this.forceResultUpdate({ _meta: {} }).then(() => {
        EventBus.trigger('search:reset', null)
      })
    }
  }
}
</script>

<style scoped>
.fsd-job-meta {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
